module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mehinaku")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "head02"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    attrs: {
      "id": "fm1"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Frontmatter01#fm_1"
    }
  }, [_vm._v("List of Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    attrs: {
      "id": "fm2"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Frontmatter02#fm_2"
    }
  }, [_vm._v("List of Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    attrs: {
      "id": "ack1"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Acknowelgement#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cont01",
    attrs: {
      "id": "pa1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part1#pa_1"
    }
  }, [_c('b', [_vm._v("1 Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter1#ch_1"
    }
  }, [_vm._v("1.   The Dramaturgical Metaphor")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#ch_2"
    }
  }, [_vm._v("2.   The Tribes of the Upper Xingu and the Mehinaku Indians")])]), _vm._v(" "), _c('p', {
    staticClass: "cont01",
    attrs: {
      "id": "pa2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part2#pa_2"
    }
  }, [_c('b', [_vm._v("2 The Setting for the Drama")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter3#ch_3"
    }
  }, [_vm._v("3.   Space, Settings, Designs")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4#ch_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.   The Design of the Community and the Flow of Information")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter5#ch_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.   Institutions and Information")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter6#ch_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.   The Institutions and Strategies of Concealment")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter7#ch_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.   What Goes On Behind the Scenes: Games Children Play")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter8#ch_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.   Theft and How to Get Away with It")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter9#ch_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.   Extramarital Sex and Concealment")])]), _vm._v(" "), _c('p', {
    staticClass: "cont01",
    attrs: {
      "id": "part3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part3#part_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 The Staging of Social Relationships")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Being Well Dressed: Preparing for Interaction")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#ch_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Greetings and Goodbyes")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#ch_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Portraits of Self")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#ch_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Withdrawal and Disengagement")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#ch_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Cycle of Seclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "cont01",
    attrs: {
      "id": "part4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part4#part_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 The Script for Social Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#ch_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Mehinaku Concept of Social Roles")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#ch_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Mehinaku Kinship")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17#ch_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Writing Your Own Ticket: Manipulating Kinship")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18#ch_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Being a Mehinaku: Tribal Identity in the Xingu System")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch19"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19#ch_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Spirits, Rituals, and Social Innovation")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch20"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20#ch_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Dilemmas of Performance: Shamanism")])]), _vm._v(" "), _c('p', {
    staticClass: "cont02",
    attrs: {
      "id": "ch21"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21#ch_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Mehinaku Social Drama")])]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "Biblio"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Bibiliography#biblio_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    attrs: {
      "id": "Indx"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Index#indx_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772d7f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 66
// module chunks = 0